import { useMutation, useQueryClient } from "@tanstack/react-query";
import { feedsUrl } from "../requests/getFeeds";
import { feedsSummaryUrl } from "../requests/getFeedsSummary";
import patchFeed from "../requests/patchFeed";
export default function useUpdateFeed(config) {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async ({ feedId, personId, request }) => {
            if (config === null) {
                throw new Error("No auth config");
            }
            return patchFeed(feedId, personId, request, config);
        },
        onMutate: ({ feedId, personId, request }) => {
            // NOTE: optimistically update query data
            queryClient.setQueryData([feedsUrl(personId)], (data) => {
                if (data) {
                    return {
                        ...data,
                        pages: data.pages.map((page) => {
                            if (page) {
                                return {
                                    ...page,
                                    values: page.values.map((feed) => feed.feedId === feedId
                                        ? { ...feed, status: request.status }
                                        : feed),
                                };
                            }
                        }),
                    };
                }
            });
        },
        onSuccess: (_, { personId }) => {
            // NOTE: invalidate all cached paginated feeds queries
            queryClient.invalidateQueries({ queryKey: [feedsUrl(personId)] });
            // NOTE: invalidate feeds summary
            queryClient.invalidateQueries({ queryKey: [feedsSummaryUrl(personId)] });
        },
    });
    return mutation.mutateAsync;
}
//# sourceMappingURL=useUpdateFeed.js.map